import { createReducer, createActions } from 'reduxsauce'
import {
  requestFeedback,
  successFeedback,
  failureFeedback,
  initialFeedback
} from 'reducers/utils'

const INITIAL_STATE = {
  contractVersionLevels: {
    feedback: initialFeedback(),
    levels: []
  }
}

const { Types, Creators } = createActions(
  {
    getContractVersionLevelsRequest: null,
    getContractVersionLevelsSuccess: ['levels'],
    getContractVersionLevelsFailure: ['errors'],
  },
  { prefix: 'MLM_RANKING_' }
)

const getContractVersionLevelsRequest = state => ({
  ...state,
  contractVersionLevels: {
    ...state.contractVersionLevels,
    feedback: requestFeedback()
  }
})

const getContractVersionLevelsSuccess = (state, { levels }) => ({
  ...state,
  contractVersionLevels: {
    feedback: successFeedback(),
    levels
  }
})

const getContractVersionLevelsFailure = (state, { errors }) => ({
  ...state,
  contractVersionLevels: {
    ...state.contractVersionLevels,
    feedback: failureFeedback(errors)
  }
})

const HANDLERS = {
  [Types.GET_CONTRACT_VERSION_LEVELS_REQUEST]: getContractVersionLevelsRequest,
  [Types.GET_CONTRACT_VERSION_LEVELS_SUCCESS]: getContractVersionLevelsSuccess,
  [Types.GET_CONTRACT_VERSION_LEVELS_FAILURE]: getContractVersionLevelsFailure,
}

export const MLMRankingActionTypes = Types
export const MLMRankingActionCreators = Creators

export default createReducer(INITIAL_STATE, HANDLERS)
